export function formatDate(date) {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${dd}.${mm}.${yyyy}`;
}

export function formatSecondsToMinutes(seconds) {
    return Math.ceil(seconds / 60);
}

export function getYearsText(number) {
    const years = number;

    const numberArr = years.toString().split("");

    if (numberArr.length === 1) {
        if (
            +numberArr[numberArr.length - 1] === 2 ||
            +numberArr[numberArr.length - 1] === 3 ||
            +numberArr[numberArr.length - 1] === 4
        ) {
            return `${years}-х лет`;
        }

        if (+numberArr[numberArr.length - 1] === 7 || +numberArr[numberArr.length - 1] === 8) {
            return `${years}-ми лет`;
        }
    }

    if (numberArr.length > 1) {
        const lastNumbers = numberArr[numberArr.length - 2].toString() + numberArr[numberArr.length - 1].toString();

        if (+lastNumbers === 12 || +lastNumbers === 13 || +lastNumbers === 14) {
            return `${years}-ти лет`;
        }

        if (
            +numberArr[numberArr.length - 1] === 2 ||
            +numberArr[numberArr.length - 1] === 3 ||
            +numberArr[numberArr.length - 1] === 4
        ) {
            return `${years}-х лет`;
        }

        if (+lastNumbers === 17 || +lastNumbers === 18) {
            return `${years}-ти лет`;
        }

        if (+numberArr[numberArr.length - 1] === 7 || +numberArr[numberArr.length - 1] === 8) {
            return `${years}-ми лет`;
        }

        if (+lastNumbers === 40 || +lastNumbers === 90) {
            return `${years} лет`;
        }
    }

    if (+numberArr[numberArr.length - 1] === 1) {
        return `${years} года`;
    }

    return `${years}-ти лет`;
}

export function scrollToElement({ el, time, animation, offset = 0 }) {
    $([document.documentElement, document.body])
        .stop()
        .animate(
            {
                scrollTop: $(el).offset().top - offset,
            },
            time,
            animation
        );
}

export function formatMoney(number) {
    return number.toLocaleString('ru-RU', { style: 'currency', currency: 'RUB' });
}

export function customFormatMoney(num) {
    num = Math.abs(+num);
    num = num.toFixed(2);

    const numSplit = num.split('.');

    let int = numSplit[0];

    if (int.length > 3) {
      int = int.substr(0, int.length - 3) + ' ' + int.substr(int.length - 3, 3);
    }

    const dec = numSplit[1];

    return int + '.' + dec
}

export function formatMoneyInput(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
      const negativeSign = amount < 0 ? "-" : "";
  
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
  
      return negativeSign +
        (j ? i.substr(0, j) + thousands : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
        (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
};